<template>
    <div>
        <div class="cart-sum">
            <div class="cart-sum__label">
                <h3 class="title is-4 has-text-grey mb-1">
                    {{ $t('orderDetails.labels.cartSum') }}
                </h3>
                <span class="is-size-5 has-text-grey"
                    >30€ Mindestbestellwert</span
                >
            </div>
            <div class="cart-sum__value">
                <template v-if="discountApplied">
                    <s class="is-5 has-text-danger is-size-6 is-block">{{
                        (isBusinessCustomer
                            ? positionPrice.beforeDiscount.netPrice
                            : positionPrice.beforeDiscount.totalPrice)
                            | toCents
                            | currency
                    }}</s>
                </template>
                <template>
                    <div class="cart-sum__value is-5">
                        <template v-if="cartSum">
                            {{
                                cartSum.netPrice | toCents | currency
                            }} </template
                        ><template v-else>
                            {{
                                (isBusinessCustomer
                                    ? positionPrice.netPrice
                                    : positionPrice.totalPrice)
                                    | toCents
                                    | currency
                            }}
                        </template>
                    </div>
                </template>
            </div>
        </div>
        <div class="cart-sum">
            <div class="cart-sum__label is-size-5">
                <div class="has-text-grey">
                    <span v-if="taxRate === 0">
                        {{ $t('checkout.cart.noTaxIncluded') }}
                    </span>
                    <span v-else-if="!isBusinessCustomer"
                        >{{
                            $t('checkout.cart.includingXPercentTaxes', {
                                taxRate,
                            })
                        }}
                    </span>
                    <span v-else>{{
                        $t('checkout.cart.plusXPercentTaxes', { taxRate })
                    }}</span>
                </div>
            </div>
            <div
                v-if="showTax && isBusinessCustomer"
                class="cart-sum__value is-size-4"
            >
                +{{ positionPrice.tax | toCents | currency }}
            </div>
        </div>
        <hr
            v-if="showTax && isBusinessCustomer"
            class="has-background-grey-light"
        />
        <div v-if="showTax && isBusinessCustomer" class="cart-sum">
            <div class="cart-sum__label"></div>
            <div class="cart-sum__value is-size-3">
                {{ positionPrice.totalPrice | toCents | currency }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { discountMixin } from '@/mixins/discountMixin';
import { calculateTaxes } from '../../../utilities/tax-calculations';

export default {
    name: 'CartSum',
    mixins: [discountMixin],
    props: {
        showTax: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        ...mapGetters([
            'positionPrice',
            'taxRate',
            'isBusinessCustomer',
            'discountApplied',
            'orderTrackingInfo',
        ]),
        cartSum() {
            if (this.orderTrackingInfo.price) {
                let netPrice =
                    this.orderTrackingInfo.price.positionPrice *
                    (1 / this.orderTrackingInfo.price.calculatedTaxes.taxRate);
                return calculateTaxes(
                    this.orderTrackingInfo.price.positionPrice,
                    this.orderTrackingInfo.price.calculatedTaxes.taxRate
                );
            }
            return null;
        },
    },
};
</script>

<style scoped></style>
